// extracted by mini-css-extract-plugin
export default {"backdrop":"overlay-styles_backdrop__Ncu4l","modal":"overlay-styles_modal__iOXnZ","modalInner":"overlay-styles_modalInner__nk2hC"};